import { SW_BRAND, SW_LOGO_BY } from './config';
import { AIRLINE_LANDINGS, airlinePath, airlineResultsPath } from './airlines';
import { AIRLINE_CONTENT, SW_AIRLINES } from './content';

export function buildAirlinePack(airline) {
  const content = AIRLINE_CONTENT[airline.slug];
  const pages = Object.fromEntries(
    AIRLINE_LANDINGS.map((item) => [item.name, airlinePath(item.slug)]),
  );

  return {
    airline,
    path: airlinePath(airline.slug),
    resultsPath: airlineResultsPath(airline.slug),
    meta: {
      title: `${airline.name} Reservations | ${SW_BRAND} by ${SW_LOGO_BY}`,
      description: content.metaDescription,
    },
    hero: content.hero,
    article: content.article,
    faqIntro: content.faqIntro,
    faqs: content.faqs,
    airlines: SW_AIRLINES.filter((item) => item.name !== airline.name).map((item) => ({
      ...item,
      href: pages[item.name],
    })),
  };
}
